var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c(
        "div",
        { staticClass: "center" },
        [
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("PAGE_NEXTYEAR_ORG_TITLE"))),
          ]),
          _c("Org", {
            ref: "org",
            attrs: {
              initData: _vm.clientEntityTree,
              onChangeFun: _vm.orgChange,
              onOrgFun: _vm.getOrg,
            },
          }),
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("COMMON_PBC_LIST"))),
          ]),
          _c("PbcList", {
            ref: "pbc",
            attrs: {
              onChangeAcitve: _vm.changeAcitve,
              loading: _vm.pbcLoading,
              initData: _vm.pbcList,
              onPbcList: _vm.getPbc,
            },
          }),
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("client003"))),
          ]),
          _c("MatterLog", {
            ref: "matter",
            attrs: {
              onChangeAcitve: _vm.changeAcitve2,
              initData: _vm.matterList,
              loading: _vm.matterLoading,
              onMatterList: _vm.getMatter,
            },
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "top-btn" },
        [
          _c("el-button", { staticClass: "wl-grey" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("comment_reSet")) + "\n    "),
          ]),
          _c(
            "el-button",
            { staticClass: "wl-green", on: { click: _vm.save } },
            [_vm._v("\n      " + _vm._s(_vm.$t("btn_save")) + "\n    ")]
          ),
        ],
        1
      ),
      _vm.addVisible
        ? _c("SavePop", {
            attrs: { onAdd: _vm.addDelayDay, onCancel: _vm.cancel },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }